import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { type FC, memo } from 'react';

const BareUnicastIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 18 17' {...props}>
    <g className='graph-icon'>
      <path
        d='M15.5 16c.827 0 1.5-.673 1.5-1.5s-.673-1.5-1.5-1.5c-.826 0-1.5.673-1.5 1.5s.674 1.5 1.5 1.5zm0-12c.827 0 1.5-.673 1.5-1.5S16.327 1 15.5 1c-.826 0-1.5.673-1.5 1.5S14.675 4 15.5 4zm0 13a2.5 2.5 0 11.001-5.001 2.5 2.5 0 010 5.001zm0-12a2.5 2.5 0 11.001-5 2.5 2.5 0 010 5z'
        fill='#B4B4B4'
      />
      <path
        d='M15.5 10a1.501 1.501 0 000-3c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5zm-13 0C3.327 10 4 9.327 4 8.5S3.327 7 2.5 7 1 7.673 1 8.5 1.673 10 2.5 10zm13 1a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm-13 0a2.5 2.5 0 11-.001-5 2.5 2.5 0 01.001 5z'
        fill='#323232'
      />
      <path
        d='M7.992 9H4.45V8h3.542V5.992L11 8.5 7.995 11l-.003-2z'
        fill='#323232'
      />
    </g>
  </SvgWrapper>
);
export const UnicastIcon = memo(BareUnicastIcon);
